/**
 * Bundle Step Configurator Module
 * Handles rendering of step configuration screens with addon selection
 */

window.BundleStepConfigurator = (function() {
  'use strict';

  /**
   * Get icon SVG helper (returns SVG not emoji despite the name)
   */
  function getIconEmoji(icon) {
    if (window.BundleAddonCard && window.BundleAddonCard.getIconEmoji) {
      return window.BundleAddonCard.getIconEmoji(icon);
    }
    // Fallback SVG icons
    const icons = {
      battery: '<svg class="icon icon-battery icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M6.5 6H17.5M6.5 6C4.01472 6 2 8.01472 2 10.5V13.5C2 15.9853 4.01472 18 6.5 18H17.5C19.9853 18 22 15.9853 22 13.5V10.5C22 8.01472 19.9853 6 17.5 6M6.5 6V4M17.5 6V4M6 10.5H10M6 13.5H14"></path></svg>',
      wheel: '<svg class="icon icon-wheel icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><circle stroke-linecap="round" stroke-linejoin="round" cx="12" cy="12" r="9"></circle><circle stroke-linecap="round" stroke-linejoin="round" cx="12" cy="12" r="3"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M12 3V9M12 15V21M3 12H9M15 12H21M5.636 5.636L9.879 9.879M14.121 14.121L18.364 18.364M18.364 5.636L14.121 9.879M9.879 14.121L5.636 18.364"></path></svg>',
      motor: '<svg class="icon icon-bolt icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M13 2L3 14H12L11 22L21 10H12L13 2Z"></path></svg>',
      speed: '<svg class="icon icon-bolt icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M13 2L3 14H12L11 22L21 10H12L13 2Z"></path></svg>',
      plate: '<svg class="icon icon-license-plate icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><rect stroke-linecap="round" stroke-linejoin="round" x="2" y="6" width="20" height="12" rx="2"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M7 10V14M10 10V14M13 10V14M16 10V14"></path></svg>',
      letter: '<svg class="icon icon-mail icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"></path></svg>',
      video: '<svg class="icon icon-video icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10L19.5528 7.72361C20.2177 7.39116 21 7.87465 21 8.61803V15.382C21 16.1253 20.2177 16.6088 19.5528 16.2764L15 14M5 18H13C14.1046 18 15 17.1046 15 16V8C15 6.89543 14.1046 6 13 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z"></path></svg>',
      shield: '<svg class="icon icon-shield icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2L4 6V12C4 17.55 7.84 22.54 12 23C16.16 22.54 20 17.55 20 12V6L12 2ZM12 12.5L8 10L9.5 14L7 17H12V12.5Z"></path></svg>',
      warranty: '<svg class="icon icon-shield icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2L4 6V12C4 17.55 7.84 22.54 12 23C16.16 22.54 20 17.55 20 12V6L12 2ZM12 12.5L8 10L9.5 14L7 17H12V12.5Z"></path></svg>',
      gift: '<svg class="icon icon-gift-box icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8V21M3 10H21M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10M3 10V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10M9 6C9 4.89543 9.89543 4 11 4C12.1046 4 13 4.89543 13 6M9 6C9 7.10457 9.89543 8 11 8H13C14.1046 8 15 7.10457 15 6M15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6"></path></svg>',
      gifts: '<svg class="icon icon-gift-box icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8V21M3 10H21M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10M3 10V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10M9 6C9 4.89543 9.89543 4 11 4C12.1046 4 13 4.89543 13 6M9 6C9 7.10457 9.89543 8 11 8H13C14.1046 8 15 7.10457 15 6M15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6"></path></svg>'
    };
    // Default package icon
    return icons[icon] || '<svg class="icon icon-package icon-lg" viewBox="0 0 25 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M7.99988 9.5L17 4M12.5 12.5L21.5 7M12.5 12.5L3.5 7M12.5 12.5V22.5M2.5 9.71771V14.2823C2.5 15.2733 2.5 15.7688 2.64219 16.2141C2.76802 16.6081 2.97396 16.9718 3.24708 17.2824C3.55572 17.6334 3.98062 17.8884 4.83042 18.3983L10.0304 21.5183C10.9283 22.057 11.3773 22.3264 11.8565 22.4316C12.2805 22.5247 12.7195 22.5247 13.1435 22.4316C13.6227 22.3264 14.0717 22.057 14.9696 21.5183L20.1696 18.3983C21.0194 17.8884 21.4443 17.6334 21.7529 17.2824C22.026 16.9718 22.232 16.6081 22.3578 16.2141C22.5 15.7688 22.5 15.2733 22.5 14.2823V9.71771C22.5 8.72669 22.5 8.23117 22.3578 7.78593C22.232 7.39192 22.026 7.02818 21.7529 6.71757C21.4443 6.36657 21.0194 6.11163 20.1696 5.60175L14.9696 2.48175C14.0717 1.94301 13.6227 1.67364 13.1435 1.56839C12.7195 1.4753 12.2805 1.4753 11.8565 1.56839C11.3773 1.67364 10.9283 1.94301 10.0304 2.48175L4.83042 5.60175C3.98062 6.11163 3.55572 6.36657 3.24708 6.71757C2.97396 7.02818 2.76802 7.39192 2.64219 7.78593C2.5 8.23117 2.5 8.72669 2.5 9.71771Z"></path></svg>';
  }

  /**
   * Render the tier progress bar
   */
  function renderTierProgress(tierInfo, totalValue, nextTierName, nextTierThreshold, amountToNext, itemsToNext) {
    // Check if progress bar should be shown from config
    const config = window.bundleAdapter?.config || {};
    const gamification = config.gamification || {};
    if (gamification.showProgressBar === false) {
      return ''; // Hide tier progress bar
    }

    const progressPercent = Math.min((totalValue / 100) * 100, 100);

    return `
      <!-- Tier Progress Bar -->
      <div class="tier-progress" style="margin: var(--sp-4) 0;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: var(--sp-2);">
          <div style="font-size: var(--text-sm); color: rgb(var(--color-drawer-text) / 0.8);">
            <span style="font-weight: 600; color: rgb(var(--color-drawer-text));">
              ${tierInfo.current === 'basic' ? 'Basic Package' : tierInfo.current === 'premium' ? 'Premium Package' : 'Elite Package'}
            </span>
            ${tierInfo.discount ? ` - Saving ${tierInfo.discount}` : ''}
          </div>
          ${amountToNext > 0 ? `
            <div style="font-size: var(--text-xs); color: rgb(var(--color-drawer-text) / 0.7);">
              ${itemsToNext} more item${itemsToNext > 1 ? 's' : ''} to ${nextTierName}
            </div>
          ` : ''}
        </div>

        <div style="position: relative; height: 12px; background: rgb(var(--color-drawer-text) / 0.1); border-radius: 6px; overflow: hidden;">
          <!-- Basic threshold at 0% -->
          <div style="position: absolute; left: 0%; top: 0; bottom: 0; width: 2px; background: rgb(var(--color-drawer-text) / 0.3); z-index: 2;"></div>

          <!-- Premium threshold at 50% -->
          <div style="position: absolute; left: 50%; top: 0; bottom: 0; width: 2px; background: rgb(var(--color-drawer-text) / 0.3); z-index: 2;"></div>

          <!-- Elite threshold at 100% -->
          <div style="position: absolute; left: 100%; top: 0; bottom: 0; width: 2px; background: rgb(var(--color-drawer-text) / 0.3); z-index: 2; transform: translateX(-2px);"></div>

          <!-- Progress fill -->
          <div style="position: absolute; left: 0; top: 0; bottom: 0; width: ${progressPercent}%; background: linear-gradient(90deg, rgb(var(--color-primary)), rgb(var(--color-primary) / 0.8)); transition: width 0.3s ease; border-radius: 6px;"></div>

          <!-- Tier labels -->
          <div style="position: absolute; left: 0; top: -20px; font-size: 10px; font-weight: 600; color: ${tierInfo.current === 'basic' ? 'rgb(var(--color-primary))' : 'rgb(var(--color-drawer-text) / 0.5)'};">Basic</div>
          <div style="position: absolute; left: 50%; top: -20px; font-size: 10px; font-weight: 600; transform: translateX(-50%); color: ${tierInfo.current === 'premium' ? 'rgb(var(--color-primary))' : 'rgb(var(--color-drawer-text) / 0.5)'};">Premium</div>
          <div style="position: absolute; right: 0; top: -20px; font-size: 10px; font-weight: 600; color: ${tierInfo.current === 'elite' ? 'rgb(var(--color-primary))' : 'rgb(var(--color-drawer-text) / 0.5)'};">Elite</div>
        </div>
      </div>
    `;
  }

  /**
   * Render main product card
   */
  function renderMainProductCard(product) {
    // Get variant name for main product (only show if multiple variants)
    let variantName = '';
    if (product.variants && product.variants.length > 1) {
      // Find selected variant - could be from selected_or_first_available_variant, or first variant
      const selectedVariant = product.selected_or_first_available_variant || product.variants[0];
      if (selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title') {
        variantName = selectedVariant.title;
      }
    }

    return `
      <div class="main-product-card" style="flex-shrink: 0; margin-bottom: var(--sp-2); padding: var(--sp-3); background: rgb(var(--color-drawer-background) / 0.5); border-radius: var(--border-radius-base); border: 1px solid rgb(var(--color-drawer-border) / 0.2);">
        <div style="display: flex; align-items: center; gap: var(--sp-4);">
          ${product.featured_image ? `
            <div style="flex-shrink: 0; width: 80px; height: 80px; border-radius: var(--border-radius-sm); overflow: hidden; background: rgb(var(--color-drawer-background));">
              <img src="${product.featured_image}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;" loading="lazy">
            </div>
          ` : ''}
          <div style="flex-grow: 1; min-width: 0;">
            <h3 style="font-size: var(--text-base); font-weight: 600; margin: 0 0 var(--sp-1) 0; color: rgb(var(--color-drawer-text)); overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
              ${product.title}
            </h3>
            ${variantName ? `
              <div style="font-size: var(--text-sm); color: rgb(var(--color-drawer-text) / 0.7); margin-bottom: var(--sp-1);">
                Colour: ${variantName}
              </div>
            ` : ''}
            <div style="display: flex; align-items: center; justify-content: space-between; gap: var(--sp-2);">
              <span style="font-size: var(--text-sm); color: rgb(var(--color-drawer-text) / 0.7);">Main Product</span>
              <span style="font-size: var(--text-lg); font-weight: 600; color: rgb(var(--color-drawer-text));">
                ${window.bundleAdapter ? window.bundleAdapter.formatPrice(product.price / 100) : `£${(product.price / 100).toFixed(2)}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Main render function for step configurator
   */
  function render(stepId, config) {
    const {
      eligibleAddons,
      customBundleSelections,
      currentStep,
      steps,
      currentProduct
    } = config;

    const stepData = {
      'performance': {
        title: 'Comfort & Safety',
        description: 'Enhance comfort with smoother rides and superior safety controls',
        options: eligibleAddons['performance'] || []
      },
      personalization: {
        title: 'Make It Uniquely Theirs',
        description: 'Add their name and personal touches',
        options: eligibleAddons.personalization || []
      },
      protection: {
        title: 'Keep It Running Perfectly',
        description: 'Protect your investment for years to come',
        options: eligibleAddons.protection || []
      },
      gifting: {
        title: 'Make Unwrapping Magical',
        description: 'Special touches for the perfect gift moment',
        options: eligibleAddons.gifting || []
      }
    };

    const step = stepData[stepId];
    if (!step) {
      console.error('[BundleStepConfigurator] Invalid step ID:', stepId);
      return '<div>Invalid step</div>';
    }

    const stepNumber = currentStep + 1;
    const totalSteps = steps.length;

    // Calculate all selections and tier info
    const allSelections = [];
    for (const s of steps) {
      if (customBundleSelections[s] && customBundleSelections[s].length > 0) {
        allSelections.push(...customBundleSelections[s]);
      }
    }

    const tierInfo = window.bundleAdapter ? window.bundleAdapter.calculateTier(allSelections) : { current: 'basic', discount: null };
    const totalValue = allSelections.reduce((sum, addon) => sum + (addon.tierValue || 0), 0);
    const actualTotal = allSelections.reduce((sum, addon) => sum + (addon.price || 0), 0);
    const itemCount = allSelections.length;

    let nextTierName = '';
    let nextTierThreshold = 0;
    let amountToNext = 0;
    let itemsToNext = 0;

    if (tierInfo.current === 'basic') {
      nextTierName = 'Premium';
      nextTierThreshold = 50;
      amountToNext = 50 - totalValue;
      itemsToNext = Math.ceil(amountToNext / 20);
    } else if (tierInfo.current === 'premium') {
      nextTierName = 'Elite';
      nextTierThreshold = 100;
      amountToNext = 100 - totalValue;
      itemsToNext = Math.ceil(amountToNext / 20);
    } else {
      nextTierName = 'Elite';
      nextTierThreshold = 100;
      amountToNext = 0;
      itemsToNext = 0;
    }

    const adapterConfig = window.bundleAdapter?.config || {};
    const tiers = adapterConfig.tiers || {};
    const tierNames = {
      basic: tiers.basic?.name || 'Included FREE',
      premium: tiers.premium?.name || 'Make It Theirs',
      elite: tiers.elite?.name || 'Premium + Protected'
    };

    let currentTierMessage = '';
    if (tierInfo.current === 'basic') {
      // Theme-aware message for basic tier
      const isChristmasTheme = window.bundleLetterPromoTheme === 'christmas';
      currentTierMessage = isChristmasTheme
        ? "Your ride-on includes a free Santa letter"
        : "Your ride-on includes a free personalised letter";
    } else if (tierInfo.current === 'premium') {
      currentTierMessage = `Perfect! You're making it uniquely theirs (saving ${tierInfo.discount})`;
    } else if (tierInfo.current === 'elite') {
      currentTierMessage = `The complete package - everything they deserve! (saving ${tierInfo.discount})`;
    }

    let nextTierMessage = '';
    if (tierInfo.current === 'basic') {
      nextTierMessage = `Add personal touches to make it theirs (save ${tiers.premium?.discount || '15%'})`;
    } else if (tierInfo.current === 'premium') {
      nextTierMessage = `Add protection and upgrades for complete peace of mind (save ${tiers.elite?.discount || '20%'})`;
    }

    // Render the step configurator
    return `
      <div class="bundle-screen active" style="display: flex; flex-direction: column; height: 100%;">
        ${renderMainProductCard(currentProduct)}

        <div class="step-options">
          ${stepId === 'gifting' ? '<p class="step-options__hint"><em>Select any gifting options you\'d like</em></p>' : ''}

          ${step.options.map(addon => {
            const stepSelections = customBundleSelections[stepId] || [];
            const isSelected = stepSelections.find(a => a.handle === addon.handle);

            // Use BundleAddonCard component if available
            if (window.BundleAddonCard && typeof window.BundleAddonCard.render === 'function') {
              return window.BundleAddonCard.render(addon, stepId, isSelected, customBundleSelections);
            }

            // Fallback to basic rendering
            const currentImage = isSelected?.featured_image || addon.featured_image;
            return `
              <div class="bundle-option ${isSelected ? 'selected' : ''}"
                   data-addon-handle="${addon.handle}"
                   data-step="${stepId}"
                   onclick="toggleAddon('${stepId}', '${addon.handle}')">
                <div class="bundle-option__content">
                  <div class="bundle-option__checkbox">
                    ${isSelected ? '<span class="bundle-option__checkbox-icon">✓</span>' : ''}
                  </div>
                  <div class="bundle-option__icon">
                    ${stepId === 'gifting' && currentImage
                      ? `<img src="${currentImage}" alt="${addon.name}" loading="lazy">`
                      : getIconEmoji(addon.icon)
                    }
                  </div>
                  <div class="bundle-option__details">
                    <div class="bundle-option__name">${addon.name}</div>
                    <div class="bundle-option__description">${addon.description || ''}</div>
                    <div class="bundle-option__price">${window.bundleAdapter ? window.bundleAdapter.formatPrice(addon.price) : `£${addon.price.toFixed(2)}`}</div>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>

        ${renderTierProgress(tierInfo, totalValue, nextTierName, nextTierThreshold, amountToNext, itemsToNext)}

        <!-- Tier Messages -->
        ${currentTierMessage || nextTierMessage ? `
          <div style="padding: var(--sp-3); margin-top: auto; border-top: 1px solid rgb(var(--color-drawer-border) / 0.2);">
            ${currentTierMessage ? `
              <div style="display: flex; align-items: center; gap: var(--sp-2); margin-bottom: ${nextTierMessage ? 'var(--sp-2)' : '0'};">
                <svg style="width: 20px; height: 20px; color: rgb(var(--color-success-text)); flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                </svg>
                <span style="font-size: var(--text-sm); color: rgb(var(--color-success-text));">${currentTierMessage}</span>
              </div>
            ` : ''}

            ${nextTierMessage && amountToNext > 0 ? `
              <div style="display: flex; align-items: center; gap: var(--sp-2);">
                <svg style="width: 20px; height: 20px; color: rgb(var(--color-primary)); flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                </svg>
                <span style="font-size: var(--text-sm); color: rgb(var(--color-drawer-text) / 0.7);">${nextTierMessage}</span>
              </div>
            ` : ''}
          </div>
        ` : ''}
      </div>
    `;
  }

  // Public API
  return {
    render: render,
    renderTierProgress: renderTierProgress,
    renderMainProductCard: renderMainProductCard
  };
})();